export const emailType = [
    'Job Application Acknowledgement',
    'Interview Invitation',
    'Screening Test',
    'Assignment',
    'Rejection',
    'Interview Confirmation',
    'Offer Letter',
    'Onboarding',
    'Promotion Announcement',
    'Performance Review',
    'Cognitive and Behavioral Test',
    'Referral',
    'Policy Update'
];